export const ENTERPRISE_TASK_CARDS = {
  llc_formation: {
    titleId: 'dashboard.enterpriseNextUp.llcFormation.title',
    descriptionId: 'dashboard.enterpriseNextUp.llcFormation.description',
    ctaUrl: '#', // tbd
    imageUrl: '/illustration/next-up-finish-your-formation.svg',
    estimate: '10',
    ctaType: null
  },
  change_of_registered_agent: {
    titleId: 'dashboard.enterpriseNextUp.registeredAgent.title',
    descriptionId: 'dashboard.enterpriseNextUp.registeredAgent.description',
    ctaUrl: '#', // tbd
    imageUrl: '/illustration/next-up-finish-your-formation.svg',
    estimate: '5',
    ctaType: null
  },
  ein_creation: {
    titleId: 'dashboard.enterpriseNextUp.einCreation.title',
    descriptionId: 'dashboard.enterpriseNextUp.einCreation.description',
    ctaUrl: '#', // tbd
    imageUrl: '/illustration/next-up-finish-your-formation.svg',
    estimate: '5',
    ctaType: null,
    infoNeeded: {
      titleId: 'dashboard.enterpriseNextUp.einCreation.infoNeeded.title',
      descriptionId: 'dashboard.enterpriseNextUp.einCreation.infoNeeded.description',
      imageUrl: '/s2/vector/product-ein.svg'
    }
  }
};
